import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=cb75cbb6&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=cb75cbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb75cbb6",
  null
  
)

export default component.exports